import styled from "styled-components";

const Container = styled.div`
    display: flex;
    flex-direction: column;
    margin-bottom: 1rem;
    border-bottom: 1px solid rgba(0, 0, 0, 0.16);
`;

export default Container;